import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class MultiUnitModel extends Model {
  @attr('string') name!: string;
  @attr('string') wifiName!: string;
  @attr('string') wifiPassword!: string;

  @belongsTo('property', { async: false, inverse: 'multiUnits' })
  property!: ModelRegistry['property'];

  @belongsTo('bulk-custom-property-attribute', { inverse: null, async: false })
  bulkCustomPropertyAttribute!: ModelRegistry['bulk-custom-property-attribute'];

  @hasMany('booking', { async: false, inverse: 'multiUnit' })
  bookings!: ModelRegistry['booking'][];

  @hasMany('unavailability', { async: false, inverse: 'multiUnit' })
  unavailabilities!: ModelRegistry['unavailability'][];

  @hasMany('booking-request', { inverse: 'multiUnit', async: false })
  bookingRequests!: ModelRegistry['booking-request'][];

  @hasMany('enquiry', { inverse: 'multiUnit', async: false })
  enquiries!: ModelRegistry['enquiry'][];

  @cached
  get forLockable(): string {
    return `↳ ${this.name}`;
  }

  @cached
  get searchName(): string {
    return this.name;
  }

  @cached
  get currency(): string {
    return this.property.currency;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'multi-unit': MultiUnitModel;
  }
}
